var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36594_9107)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#5E6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98501 13.9829L13.7969 10.4718C13.8779 10.4225 13.9449 10.3531 13.9913 10.2704C14.0378 10.1877 14.0622 10.0944 14.0622 9.99958C14.0622 9.90472 14.0378 9.81145 13.9913 9.72875C13.9449 9.64604 13.8779 9.57667 13.7969 9.52732L7.98501 6.0163C7.9017 5.96639 7.80662 5.93954 7.70951 5.93851C7.61241 5.93747 7.51677 5.96229 7.43242 6.01041C7.34807 6.05853 7.27804 6.12822 7.22951 6.21234C7.18098 6.29645 7.1557 6.39197 7.15626 6.48908V13.5101C7.1557 13.6072 7.18098 13.7027 7.22951 13.7868C7.27804 13.871 7.34807 13.9406 7.43242 13.9888C7.51677 14.0369 7.61241 14.0617 7.70951 14.0607C7.80662 14.0596 7.9017 14.0328 7.98501 13.9829Z",
    fill: "#5E6068"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36594_9107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a2ae777c595ac736fbdbd40e970b69d4.svg";
export { ForwardRef as ReactComponent };